"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const If = (props) => {
    if (props.test) {
        return props.children;
    }
    if (props.orElse) {
        return props.orElse;
    }
    return null;
};
exports.default = If;
